// extracted by mini-css-extract-plugin
export default {"price":"y7-z","priceRow":"z7-z","onSale":"A7-z","msrpLabelPrice":"B7-z","msrpLabel":"C7-z","originalPrice":"D7-z","percentOff":"E7-z"};